<template>
  <div>
    <Headers :windowWidth="windowWidth" />
    <div class="createAccount_wrap">

      <!-- 搜索 -->
      <div class="search">
          <el-row type="flex" align="bottom"  :gutter="20">
              <el-col :span="7">
                  <div class="search_t">User Name</div>
                  <el-input v-model="fromData.userName" clearable placeholder="User Name"></el-input>
              </el-col>
              <el-col :span="7">
                  <div class="search_t">Status</div>
                  <el-select v-model="fromData.status" style="width:100%" clearable placeholder="All">
                      <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </el-col>
              <el-col :span="7">
                  <div class="search_t">User Role</div>
                  <el-select v-model="fromData.userType" style="width:100%" clearable placeholder="All">
                      <el-option
                      v-for="item in userTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      </el-option>
                  </el-select>
              </el-col>
              <el-col :span="3">
                  <div class="search_btn" @click="getlistByCondition()">Search</div>
              </el-col>
          </el-row>
      </div>

      <!-- add -->
      <el-row type="flex" justify="space-between" style="margin-bottom:50px">
          <el-col>
              <el-button class="save" @click="changeupload">Create User</el-button>
          </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        :data="tabList"
        stripe
        :header-cell-style="{
          background: '#F0F3F6',
          color: '#626262',
          fontSize: '14px',
          fontFamily: 'ArialMT',
          paddingTop: '17px',
          paddingBottom: '15px',
          paddingLeft: '20px',
        }"
        :cell-style="columnStyle"
        style="width: 100%"
      >
        <!-- 空状态 -->
        <template slot="empty">
          <p style="margin-top: 50px">
            <img class="data-pic" src="../../assets/img/noData.png" alt="" />
          </p>
          <p class="nodata">No Data</p>
        </template>
        <el-table-column prop="username" :label="$t('createAccount.tabUserName')">
            <template slot-scope="scope">
                <div class="detail_txt" @click="gotoDetail(scope.row)">{{scope.row.username}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('createAccount.status')">
            <template slot-scope="scope">
                <div v-if="scope.row.status == '0'">Inactive</div>
                <div v-if="scope.row.status == '1'">Active</div>
                <div v-if="scope.row.status == '2'">Pending</div>
                <div v-if="scope.row.status == '3'">Rejected</div>
                <div v-if="scope.row.status == '4'">Retired</div>
            </template>
        </el-table-column>
        <el-table-column label="User Role(s)">
            <template slot-scope="scope">
                <div>
                    <div>{{ scope.row.allRoles }}</div>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="createTime" label="Creation Time">
            <template slot-scope="scope">
                <div>{{formatDates(scope.row.createTime)}}</div>
            </template>
        </el-table-column>
        <el-table-column width="300" :label="$t('createAccount.action')">
            <template slot-scope="scope">
                <div class="flex_box">
                    <div class="txt Reactive" @click="getuserstatus(scope.row,1)" v-if="scope.row.status == '0'">Reactive</div>
                    <div class="txt Reactive" @click="getuserstatus(scope.row,1)" v-if="scope.row.status == '2'">Approve</div>
                    <div class="txt Delete" @click="getuserdelete(scope.row)" v-if="scope.row.status == '0'">Delete</div>
                    <div class="txt Delete" @click="getuserstatus(scope.row,3)" v-if="scope.row.status == '2'">Reject</div>
                    <div class="txt Disable" @click="getuserstatus(scope.row,0)" v-if="scope.row.status == '1'">Disable</div>
                </div>
            </template>
        </el-table-column>
      </el-table>


      <el-row type="flex" justify="space-between" style="margin-top:20px">
          <el-col>
              <el-button class="save back" @click="back">{{$t('createAccount.Back')}}</el-button>
          </el-col>
      </el-row>
    </div>


    <div class="btm_dia_up">
        <el-dialog title="" :close-on-click-modal="false" :visible.sync="upload_dia" width="960px" center>
            <div class="dia_banner">
                <div class="title">Open a New Account</div>
                <div class="title2">Select an account type and press the "Continue " button.</div>
                <!-- 选择 -->
                <div class="box">

                    <div class="border_box" :class="type == 4 ? 'g_b' : ''" @click="changeType(4)">
                        <div>
                            <img src="../../assets/img/Account Holder@2x.png" class="ban" alt="">
                        </div>
                        <div class="txt">Company</div>
                        <div class="dui_box" v-if="type == 4">
                            <img src="../../assets/img/dui.png" class="dui" alt="">
                        </div>
                    </div>

                    <div class="border_box mg_l_50" :class="type == 5 ? 'g_b' : ''" @click="changeType(5)">
                        <div>
                            <img src="../../assets/img/Agency.png" class="ban" alt="">
                        </div>
                        <div class="txt">Agency</div>
                        <div class="dui_box" v-if="type == 5">
                            <img src="../../assets/img/dui.png" class="dui" alt="">
                        </div>
                    </div>
                </div>
                <div class="up_btn" @click="save">Continue</div>
            </div>
        </el-dialog>
    </div>

    
  </div>
</template>
<script>
import Headers from "@/components/header/index.vue";
import carbon from "@/api/carbon.js";
import { formatDate } from '@/util/date.js'
export default {
  components: { Headers },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      status: false,
      upload_dia:false,
      checkList: [],
      fromData:{
        userName:"",
        status:"",
        userType:"",
      },
      userinfo:{},
      statusList:[
          {
              value: '0',
              label: 'Inactive'
          },
          {
              value: '1',
              label: 'Active'
          },
          {
              value: '2',
              label: 'Pending'
          },
          {
              value: '3',
              label: 'Rejected'
          },
          {
              value: '4',
              label: 'Retired'
          },
      ],
      userTypeList:[
          {
              value: 'A1',
              label: 'A1'
          },
          {
              value: 'A2',
              label: 'A2'
          },
          {
              value: 'B1',
              label: 'B1'
          },
          {
              value: 'B2',
              label: 'B2'
          },
          {
              value: 'C1',
              label: 'C1'
          },
          {
              value: 'C2',
              label: 'C2'
          },
          {
              value: 'C1+A1',
              label: 'C1+A1'
          },
          {
              value: 'C2+A1',
              label: 'C2+A1'
          },
          {
              value: 'C3+A1',
              label: 'C3+A1'
          },
          {
              value: 'A2+C1',
              label: 'A2+C1'
          },
          {
              value: 'A3+C1',
              label: 'A3+C1'
          },
      ],
      tabList: [],
      pageSize: 10,
      currentPage: 1,
      type:4,
    };
  },
  mounted() {
    this.userinfo = JSON.parse(sessionStorage.getItem('login'))
    this.getlistByCondition()
    let that = this;
    window.onresize = () => {
      return (() => {
        window.fullWidth = document.documentElement.clientWidth;
        (that.windowWidth = document.documentElement.clientWidth), //实时屏幕宽度
          (that.windowHeight = window.fullHeight); // 高
      })();
    };
  },
  methods:{
    formatDates(val){
      return formatDate(val)
    },
    columnStyle({ row, column, rowIndex, columnIndex}){
      
      return "word-break:break-word;padding-left:20px";
    },
      //翻页
    handleCurrentChange(updateCurrentPage) {
      this.currentPage = updateCurrentPage;
    },
    save(){
        this.$router.push({
          path:"/createAccount",
          query:{
            type:this.type
          },
        })
    },
    getlistByCondition(){
        let params = {
            createUserId:this.userinfo.id,
            username:this.fromData.userName,
            status:this.fromData.status,
            userType:this.fromData.userType,
        }
        carbon.getlistByCondition((res) => {
            if(res.code == 200){
                this.tabList = res.data
            }
        },params);
    },
    getuserstatus(val,tp){
        let params = {
            id:val.id,
            status:tp
        }
        carbon.getuserstatus((res) => {
            if(res.code == 200){
                this.getlistByCondition()
            }
        },params);
    },
    getuserdelete(val,tp){
        let params = {
            id:val.id,
        }
        carbon.getuserdelete((res) => {
            if(res.code == 200){
                this.getlistByCondition()
            }
        },params);
    },
    gotoDetail(row){
        this.$router.push({
            path:'/accountDetail',
            query:{
                id:row.id
            },
        })
    },
    changeupload(){
      this.upload_dia = true
    },
    changeType(val){
      this.type = val
    },
    back(){
        this.$router.go(-1)   
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .btm_dia_up{
    .el-dialog{
        margin-top: 15vh !important;
    }
}
.g_b{
  border-color: #158869 !important;
}
::v-deep .el-dialog{
  margin-top: 40vh !important;
  // height: 311px;
  border-radius: 30px;
  .el-dialog__title{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .el-divider--horizontal{
    margin-top: 0;
  }
  .dialog_box_title{
    font-size: 14px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #21212B;
    line-height: 20px;
    margin-bottom: 20px;
  }
  .dialog_title{
    padding-top: 10px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
  }
  .dialog_title_txt{
    font-size: 14px;
    font-family: ArialMT;
    color: #626262;
    line-height: 24px;
  }
  .dialog_titles{
    text-align: center;
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
  }
  .ipt_box{
    width: 460px;
    margin:0 auto
  }
  .dialog_flex{
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    .textone{
      font-size: 16px;
      font-family: ArialMT;
      color: #21212B;
      line-height: 23px;
      text-align: left;
      font-weight: 600;
    }
    .texttwo{
      text-align: right;
      font-size: 16px;
      font-family: Arial-BoldMT, Arial;
      // font-weight: 600;
      color: #626262;
      line-height: 26px;
    }
  }
  .el-icon-close:before{
    content: url('../../assets/img/guanbi.png');
  }
}
.createAccount_wrap {
  width: 1440px;
  height: 838px;
  background: #f8f9fa;
  margin: 0 auto;
  margin-top: 50px;
  border-radius: 20px;
  padding: 74px 42px 105px 52px;
  .save{
        width: 125px;
        height: 44px;
        background: #158869;
        border-radius: 4px;
        font-size: 16px;
        font-family: ArialMT;
        color: #FFFFFF;
    }
    .back{
        background-color: #F8F9FA;
        border-color: #97A5B7;
        color: #97A5B7;
    }
    .edit{
        width: 85px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #158869;
        color: #158869;
        font-size: 14px;
        font-family: ArialMT;
    }
    .delete{
        border: 1px solid #DC5F5F;
        color: #DC5F5F;
    }
    ::v-deep .el-button{
        padding: 0;
    }
}
.search{
    margin-bottom:50px;
    .search_t{
        font-size: 14px;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:10px;
    }
    .search_btn{
        width: 130px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #158869;
        font-size: 16px;
        color: #158869;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.flex_box{
  display: flex;
  // justify-content: center;
  align-items: center;
  cursor: pointer;
  .txt{
    font-size: 16px;
    font-family: ArialMT;
    margin-right: 18px;
  }
  .Reactive{
    color: #158869;
  }
  .Delete{
    color: #ED6666;
  }
  .Disable{
    color: #A6ADB5;
  }
}
.dia_banner{
  .title{
    font-size: 40px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #1E1E1E;
    line-height: 45px;
    text-align: center;
  }
  .title2{
    font-size: 20px;
    font-family: ArialMT;
    color: #626262;
    line-height: 23px;
    text-align: center;
    margin: 24px 0 70px 0;
  }
  .box{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .border_box{
    width: 390px;
    height: 220px;
    border-radius: 8px;
    border: 1px solid rgba(0,20,42,0.1);
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .ban{
    width: 80px;
    height: 80px;
    margin-bottom: 15px;
  }
  .txt{
    font-size: 20px;
    font-family: ArialMT;
    color: #1E1E1E;
    line-height: 23px;
  }
  .dui_box{
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .mg_l_50{
    margin-left: 50px;
  }
  .dui{
    width: 25px;
    height: 25px;
  }
  .up_btn{
      margin: 50px auto;
      width: 125px;
      height: 44px;
      background: #158869;
      border-radius: 4px;
      font-size: 16px;
      font-family: ArialMT;
      color: #FFFFFF;
      line-height: 18px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
  }
}
.detail_txt{
  cursor: pointer;
  color: #158869;
}
.flex_tb{
  display: flex;
  align-items: center;
}
</style>